export default __webpack_public_path__ + "static/media/users.49a6968b.svg";